<div class="dialog-container">
  <div class="title">
    <mat-icon>add_box</mat-icon>
    <span>Manage Form Sections</span>
  </div>
  <div class="sections-container">
    @for (section of sectionForm.sections; track section) {
      <div
        class="toggle-selector"
        id="toggles"
        >
        <mat-slide-toggle
          [checked]="section.selected"
          (toggleChange)="sectionSelectionChange(section.id)"
          >
          {{ section.name }}
        </mat-slide-toggle>
      </div>
    }
  </div>
  <div class="button-container">
    <button id="back" (click)="back()" mat-button>
      <mat-icon>keyboard_backspace</mat-icon>BACK
    </button>
    <button id="add-items" (click)="create()" mat-button color="primary">
      CREATE
    </button>
    <button id="cancel-add-items" (click)="cancel()" mat-button>CANCEL</button>
  </div>
</div>
